<template>
  <div class="container new_list_blog mb-5" id="new_list_blog">


    <div class="tags-group">
      <p class="tag-select-title">{{ $t('Filter') }}</p>
      <div class="tag-select btn btn-white" v-for="tag in widgetData.tags" @click="toggleTag(tag.id)"
           :key="tag.id" :class="{'selected': isTagSelected(tag.id)}">#{{ tag.name }}
      </div>
    </div>

    <div class="blog-items" v-if="activeContent.length > 0">
      <NuxtLink class="b-item card-group" :to="blog.getLinkWithSlash()" :title="blog.title"
                v-for="blog in activeContent" :key="blog.id" key="1000000">
        <div class="card">
          <div class="card-header">
            <figure>
              <picture>

                <template v-if="blog.hasImage()">
                  <PartsImageSourceList :image="blog.getTopImage()" :sizes="[700,900]"/>
                  <img :src="blog.getTopImage().getTyrionSrc('cachew')"
                       :alt="blog.getTopImage().title"
                       itemprop="photo"
                       class="big-photo img-cover" loading="lazy"
                       :width="blog.getTopImage().seoWidth($isDesktop ? 'cache' : 'thumb')"
                       :height="blog.getTopImage().seoHeight($isDesktop ? 'cache' : 'thumb')">
                </template>
                <img v-else src="~/assets/img/blank.jpg" :alt="blog.title" class="img-cover" loading="lazy"
                     width="600" height="337">
              </picture>
            </figure>
          </div>
          <div class="card-body">

            <div class="tags">
              <p v-if="blog.tags && blog.tags.length > 0" v-for="tag in limitedTags(blog.tags)"
                 class="tag">#{{ tag.name }}&nbsp;</p>
            </div>

            <h2 class="title">{{ blog.title }}</h2>

            <div class="desc-info">
              <p v-if="blog.date_public && blog.date_public.length > 0"
                 class="date">
                <TyIcon icon="ty-calendar-2"/>
                {{ formatTime(blog.date_public, 'D. MMMM YYYY') }}
              </p>
              <p class="author d-none" rel="autor" v-if="blog.author">{{ blog.author.blog_name }}</p>
            </div>

          </div>
          <div class="card-footer">
            <p class="show-more">{{ $t('show-more') }}
              <TyIcon icon="ty-arrow-right"/>
            </p>
          </div>
        </div>
      </NuxtLink>
    </div>
    <div class="row" v-else>
      <div class="alert alert-info">
        {{ $t('no-blog-in-category') }}
      </div>
    </div>

  </div>
</template>


<script setup lang="ts">
import {computed, PropType, ref} from "vue";
import {useWidget} from "~/composables/widget/news_list";
import {PageDataHolderFetchedWidget} from "../../../../lib/interfaces/model/PageDataHolderFetchedWidget";
import {formatTime} from "../../../../lib/functions";
import "~/assets/less/news_list_blog.min.css";
import {useNuxtApp} from "nuxt/dist/app";

const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});

const {widgetData, content, $isDesktop, masterPage} = useWidget(props.widget);
const selectedTags = ref<Array<Number>>([]);

const limitedTags = (tags) => {
  return tags.slice(0, 2);
};

const toggleTag = (tagId) => {
  if (isTagSelected(tagId)) {
    selectedTags.value.splice(selectedTags.value.indexOf(tagId), 1);
  } else {
    selectedTags.value.push(tagId);
  }
}

const isTagSelected = (tagId) => {
  return selectedTags.value.indexOf(tagId) > -1;
}

const activeContent = computed(() => {
  if (selectedTags.value.length === 0) {
    return content;
  } else {
    return content.filter(item => {
      return item.tags.some(tag => {
        return isTagSelected(tag.id);
      })
    })
  }
})

</script>


